import swal from 'sweetalert2'

import { Button, Form } from '@domain-group/suit-theme'

import handleCallbackAction from '@functions/handleCallbackAction'

import type { UseBrowseCampaignComparablesModalPayload } from '../../hooks/useBrowseCampaignComparablesModal'

const confirmPropertyMatchOverride = (
  hookPayload: UseBrowseCampaignComparablesModalPayload,
) => {
  const {
    agencyDataProviderTitle,
    callbacks: {
      updateCampaignDataProvider,
      setModalState,
    },
    propertyMatchId,
  } = hookPayload

  const dataProvider = agencyDataProviderTitle || 'Data Provider'

  const updateDataProviderPayload = {
    callbacks: {
      action: updateCampaignDataProvider,
      afterAction: setModalState({ propertyMatchId: '' }),
    },
    entityParams: {
      data_provider: dataProvider,
      id: propertyMatchId,
    },
    toastText: 'Property Match Override',
  }

  swal.fire({
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes, Set Property Match Id.',
    icon: 'warning',
    showCancelButton: true,
    text: `Are you sure? You are manually setting or overriding the ${dataProvider} property match id. This can be undone by clicking 'Reset Property Match'.`,
    title: 'Manually Set Property Match?',
  }).then(({ value }) => {
    if (value){
      // @ts-expect-error TS2345
      handleCallbackAction(updateDataProviderPayload)
    }
  })
}

interface SetPropertyMatchProps {
  hookPayload: UseBrowseCampaignComparablesModalPayload,
}

const SetPropertyMatch = (props: SetPropertyMatchProps) => {
  const { hookPayload } = props

  const {
    callbacks: {
      setModalState,
    },
    propertyMatchId,
  } = hookPayload

  return (
    <>
      <Form.Field>
        <input
          onChange={e => setModalState({ propertyMatchId: e.target.value })}
          type="text"
          value={propertyMatchId}
        />
      </Form.Field>

      <Button
        buttonStyle="primaryEdit"
        // @ts-expect-error
        marginTop="medium"
        onClick={() => confirmPropertyMatchOverride(hookPayload)}
        size="medium"
      >
        Manually Set Property Match ID
      </Button>

    </>
  )
}

export default SetPropertyMatch
